module.exports = __webpack_public_path__ + "static/img/home-top1.57e7527.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/home-top1.png
// module id = SyeV
// module chunks = 21